module.exports = __webpack_public_path__ + "static/media/brand.25f19ae5.png";